import React, { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@mui/material";
import { connect, useDispatch, useSelector } from "react-redux";

import { handleEditHost } from "../../store/host/host.action";
import { CLOSE_HOST_DIALOG } from "../../store/host/host.type";
import ReactDropzone from "react-dropzone";
import noImage from "../../assets/img/female.png";

const HostEdit = (props) => {
  const { dialog: open, dialogueData } = useSelector((state) => state.host);
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [bio, setBio] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const [coin, setCoin] = useState("");
  const [gender, setGender] = useState("");
  const [country, setCountry] = useState("");
  const [album, setAlbum] = useState([]);
  const [error, setError] = useState({});
  const [profileImage, setProfileImage] = useState(null);
  const [profileImagePath, setProfileImagePath] = useState("");
  const [mongoId, setMongoId] = useState("");
  const [mobileNo, setMobileNo] = useState("");

  useEffect(() => {
    if (dialogueData) {
      setMongoId(dialogueData?._id);
      setName(dialogueData?.name || "");
      setEmail(dialogueData?.email || "");
      setBio(dialogueData?.bio || "");
      setGender(dialogueData?.gender || "");
      setCountry(dialogueData?.country || "");
      setAge(dialogueData?.age ?? "");
      setCoin(dialogueData?.coin ?? "");
      setProfileImagePath(dialogueData?.image || "");
      setAlbum(dialogueData?.album || []);
      setMobileNo(dialogueData?.mobileNumber || "");
      setProfileImage(null);
      setError({});
    }
  }, [dialogueData]);

  const handleClose = () => dispatch({ type: CLOSE_HOST_DIALOG });

  const handleImage = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setProfileImage(f);
    setProfileImagePath(URL.createObjectURL(f));
    setError((p) => ({ ...p, profileImage: "" }));
  };

  const onPreviewDrop = (files) => {
    setError((p) => ({ ...p, album: "" }));
    files.forEach((file) => Object.assign(file, { preview: URL.createObjectURL(file) }));
    setAlbum(album.concat(files));
  };

  const removeImage = (file) => setAlbum(album.filter((f) => f !== file));

  const handleSubmit = () => {
    const err = {};
    if (!name) err.name = "İsim zorunlu";
    if (!email) err.email = "E-posta zorunlu";
    if (!bio) err.bio = "Biyografi zorunlu";
    if (!country) err.country = "Ülke zorunlu";
    if (!gender) err.gender = "Cinsiyet seçilmeli";
    if (age !== "" && Number(age) < 18) err.age = "Yaş 18'den küçük olamaz";
    if (coin !== "" && Number(coin) < 0) err.coin = "Coin negatif olamaz";
    if (!profileImagePath) err.profileImage = "Profil görseli zorunlu";
    if (!album || album.length === 0) err.album = "En az bir görsel gerekli";
    // telefon girildiyse 10 hane olmali
    if (mobileNo && !/^\d{10}$/.test(mobileNo)) err.mobileNo = "Telefon 10 haneli olmalı";

    if (Object.keys(err).length) return setError(err);

    const formData = new FormData();
    formData.append("hostId", mongoId);
    formData.append("name", name);
    formData.append("email", email);
    // bio eskiden hic gonderilmiyordu: zorunlu tutulup kaydedilmiyordu
    formData.append("bio", bio);
    formData.append("age", age);
    formData.append("country", country);
    formData.append("coin", coin);
    formData.append("gender", gender);
    if (profileImage) formData.append("image", profileImage);
    formData.append("mobileNumber", mobileNo || "");
    for (let i = 0; i < album.length; i++) formData.append("album", album[i]);

    props.handleEditHost(mongoId, formData);
    handleClose();
  };

  const onKey = (e) => {
    if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") handleSubmit();
  };

  const S = styles;

  const Field = ({ label, children, err, full }) => (
    <div style={{ ...S.field, ...(full ? { gridColumn: "1 / -1" } : {}) }}>
      <label style={S.label}>{label}</label>
      {children}
      {err && <div style={S.err}>{err}</div>}
    </div>
  );

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" PaperProps={{ style: S.paper }}>
      <div style={S.head}>
        <div>
          <div style={S.title}>Yayıncıyı düzenle</div>
          <div style={S.sub}>{dialogueData?.name}</div>
        </div>
        <button type="button" style={S.close} onClick={handleClose} aria-label="Kapat">
          ×
        </button>
      </div>

      <DialogContent style={S.body}>
        <div style={S.grid} onKeyDown={onKey}>
          <Field label="İsim" err={error.name}>
            <input style={S.input} value={name} onChange={(e) => setName(e.target.value)} placeholder="İsim" />
          </Field>

          <Field label="E-posta" err={error.email}>
            <input style={S.input} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-posta" />
          </Field>

          <Field label="Biyografi" err={error.bio} full>
            <textarea
              style={{ ...S.input, height: 72, resize: "vertical" }}
              value={bio}
              onChange={(e) => setBio(e.target.value)}
              placeholder="Kısa tanıtım"
            />
          </Field>

          <Field label="Yaş" err={error.age}>
            <input style={S.input} type="number" value={age} onChange={(e) => setAge(e.target.value)} placeholder="18" />
          </Field>

          <Field label="Telefon" err={error.mobileNo}>
            <input
              style={S.input}
              value={mobileNo}
              onChange={(e) => setMobileNo(e.target.value)}
              placeholder="10 haneli (isteğe bağlı)"
            />
          </Field>

          <Field label="Ülke" err={error.country}>
            <input style={S.input} value={country} onChange={(e) => setCountry(e.target.value)} placeholder="Ülke" />
          </Field>

          <Field label="Coin" err={error.coin}>
            <input style={S.input} type="number" value={coin} onChange={(e) => setCoin(e.target.value)} placeholder="0" />
          </Field>

          <Field label="Cinsiyet" err={error.gender} full>
            <div style={S.radios}>
              {[
                ["Male", "Erkek"],
                ["Female", "Kadın"],
              ].map(([val, txt]) => (
                <button
                  key={val}
                  type="button"
                  style={{ ...S.radio, ...(gender === val ? S.radioOn : {}) }}
                  onClick={() => setGender(val)}
                >
                  {txt}
                </button>
              ))}
            </div>
          </Field>

          <Field label="Profil görseli" err={error.profileImage} full>
            <div style={S.profileRow}>
              <img
                src={profileImagePath || noImage}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                alt=""
                style={S.profileImg}
              />
              <label style={S.fileBtn}>
                Görsel seç
                <input type="file" accept="image/*" onChange={handleImage} style={{ display: "none" }} />
              </label>
            </div>
          </Field>

          <Field label="Albüm görselleri" err={error.album} full>
            <div style={S.albumRow}>
              <ReactDropzone onDrop={onPreviewDrop} accept="image/*">
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()} style={S.drop}>
                    <input {...getInputProps()} />
                    <span style={S.dropPlus}>+</span>
                  </div>
                )}
              </ReactDropzone>

              {album?.map((file, i) => (
                <div key={i} style={S.thumbWrap}>
                  <img
                    src={file?.preview ? file.preview : file}
                    alt=""
                    style={S.thumb}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = noImage;
                    }}
                  />
                  <button type="button" style={S.thumbX} onClick={() => removeImage(file)} aria-label="Kaldır">
                    ×
                  </button>
                </div>
              ))}
            </div>
          </Field>
        </div>
      </DialogContent>

      <div style={S.foot}>
        <button type="button" style={{ ...S.btn, ...S.btnGhost }} onClick={handleClose}>
          Vazgeç
        </button>
        <button type="button" style={{ ...S.btn, ...S.btnPrimary }} onClick={handleSubmit}>
          Kaydet
        </button>
      </div>
    </Dialog>
  );
};

const styles = {
  paper: { borderRadius: 16, background: "#fff" },
  head: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: "20px 22px 12px",
    borderBottom: "1px solid #eef1f6",
    background: "#fff",
  },
  title: { fontSize: 18, fontWeight: 700, color: "#1b2334" },
  sub: { fontSize: 13, color: "#8b93a7", marginTop: 2 },
  close: {
    border: "none",
    background: "#f2f4f8",
    color: "#5b6478",
    width: 32,
    height: 32,
    borderRadius: 8,
    fontSize: 20,
    lineHeight: "20px",
    cursor: "pointer",
  },
  body: { padding: "18px 22px", background: "#fff" },
  grid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 },
  field: { display: "flex", flexDirection: "column", minWidth: 0 },
  label: { fontSize: 12.5, fontWeight: 600, color: "#42506b", marginBottom: 6 },
  input: {
    border: "1px solid #dde2ec",
    borderRadius: 10,
    padding: "10px 12px",
    fontSize: 14,
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    background: "#fff",
  },
  err: { color: "#b42318", fontSize: 12, marginTop: 4 },
  radios: { display: "flex", gap: 8 },
  radio: {
    border: "1px solid #dde2ec",
    background: "#fff",
    color: "#42506b",
    borderRadius: 10,
    padding: "9px 22px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
  },
  radioOn: { background: "#4361ee", borderColor: "#4361ee", color: "#fff" },
  profileRow: { display: "flex", alignItems: "center", gap: 14 },
  profileImg: { width: 66, height: 66, borderRadius: 12, objectFit: "cover", background: "#f2f4f8" },
  fileBtn: {
    border: "1px solid #dde2ec",
    borderRadius: 10,
    padding: "9px 16px",
    fontSize: 14,
    fontWeight: 600,
    color: "#42506b",
    cursor: "pointer",
    background: "#fff",
  },
  albumRow: { display: "flex", flexWrap: "wrap", gap: 10, alignItems: "center" },
  drop: {
    width: 66,
    height: 66,
    border: "2px dashed #c9d1e2",
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#9aa3b8",
  },
  dropPlus: { fontSize: 30, lineHeight: "30px" },
  thumbWrap: { position: "relative" },
  thumb: { width: 66, height: 66, borderRadius: 12, objectFit: "cover", background: "#f2f4f8" },
  thumbX: {
    position: "absolute",
    top: -6,
    right: -6,
    width: 22,
    height: 22,
    borderRadius: 11,
    border: "none",
    background: "#f04438",
    color: "#fff",
    fontSize: 15,
    lineHeight: "15px",
    cursor: "pointer",
  },
  foot: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 8,
    padding: "14px 22px 20px",
    borderTop: "1px solid #eef1f6",
    background: "#fff",
  },
  btn: {
    border: "1px solid transparent",
    borderRadius: 10,
    padding: "9px 20px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
  },
  btnGhost: { background: "#fff", borderColor: "#dde2ec", color: "#42506b" },
  btnPrimary: { background: "#4361ee", color: "#fff" },
};

export default connect(null, { handleEditHost })(HostEdit);
